export const PAYMENT_NO_PERIOD_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Auszahlung der Summe ohne Wartezeit</b>
    </p>

    <p>
      Der Versicherungsschutz gilt ab dem ersten Tag des Vertragsbeginns ohne Wartezeit. Die von
      Ihnen
      <b>festgelegte Versicherungssumme wird ohne die Vorlage eines Erbscheins</b> direkt an die
      <b> von Ihnen bestimmte/n bezugsberechtigte/n Person/en oder Erben</b> ausgezahlt.
    </p>
  </div>
);

export const BASIC_AFTER_INSURANCE_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Erhöhung der Summe ohne erneute Gesundheitsprüfung</b>
    </p>

    <p>
      Die <b>Erhöhung der Versicherungssumme</b> kann bei{' '}
      <b>bestimmten Ereignissen ohne erneute Gesundheitsprüfung</b> im Rahmen der
      Nachversicherungsgarantie erfolgen. Dazu zählen z. B. Heirat, Geburt oder Adoption eines
      Kindes, Kauf oder Bau einer Immobilie sowie die Aufnahme eines Darlehens von mindestens 50.000
      € für Wohneigentum. In diesem Zusammenhang werden Sie lediglich gefragt, ob Sie rauchen.
    </p>
    <p>
      <b>
        Unabhängig von diesen Ereignissen besteht auch die Möglichkeit, die Versicherungssumme
        mehrfach mit einer Gesundheitsprüfung zu erhöhen.
      </b>
    </p>
  </div>
);

export const PROVISIONAL_COVER_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Vorläufiger Versicherungsschutz</b>
    </p>

    <p>
      Sie sind bereits ab Antragseingang vorläufig mit 200.000 € bei Tod durch Unfall abgesichert.
      Die Summe wird sogar vor dem offiziellen Vertragsbeginn an Ihre Hinterbliebenen ausgezahlt,
      falls Sie durch einen Unfall ums Leben kommen.
    </p>
  </div>
);

export const EARLY_DEATH_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Vorgezogene Todesfallleistung bei schwerer Krankheit</b>
    </p>

    <p>
      Sie erhalten auf Wunsch <b>die volle Versicherungssumme zu Lebzeiten</b>, falls Ihre{' '}
      <b>Lebenserwartung aufgrund einer schweren Erkrankung von einem Facharzt auf weniger als ein Jahr</b> geschätzt wird.
    </p>
  </div>
);

export const BENEFITS_FROM_BASIC_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Inklusive aller Leistungen aus dem Grundschutz</b>
    </p>

    <p>In Komfort enthalten sind alle Leistungen aus dem Grundschutz, wie z. B.:</p>
    <ul>
      <li>Auszahlung der Summe ohne Wartezeit</li>
      <li>Erhöhung der Summe ohne erneute Gesundheitsprüfung</li>
      <li>Vorgezogene Todesfallleistung bei schwerer Krankheit</li>
    </ul>
  </div>
);

export const BENEFITS_FROM_BASIC_TOOLTIP_GREATER_50 = (
  <div className="tooltip">
    <p>
      <b>Inklusive aller Leistungen aus dem Grundschutz</b>
    </p>
    <p>In Komfort enthalten sind alle Leistungen aus dem Grundschutz, wie z. B.:</p>
    <ul>
      <li>Auszahlung der Summe ohne Wartezeit</li>
      <li>Vorläufiger Versicherungsschutz</li>
      <li>Vorgezogene Todesfallleistung bei schwerer Krankheit</li>
    </ul>
  </div>
);

export const AFTER_INSURANCE_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Erweiterte Erhöhung der Summe ohne erneute Gesundheitsprüfung</b>
    </p>

    <p>
      Sie haben die Möglichkeit, die <b>Versicherungssumme</b> bei{' '}
      <b>bestimmten Ereignissen ohne erneute Gesundheitsprüfung zu erhöhen</b>, z. B. bei Heirat,
      Geburt oder Adoption eines Kindes, Kauf oder Bau einer Immobilie und/oder Aufnahme eines
      Darlehens sowie <b>zusätzlich</b> bei Selbstständigkeit, Unternehmensgründung, Tod des
      Ehepartners oder Scheidung/Trennung, Krediten für Modernisierungen und vielen weiteren
      Anlässen. In diesem Zusammenhang werden Sie lediglich gefragt, ob Sie rauchen.
    </p>
  </div>
);

export const TEMPORARY_INCREASE_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Temporäre Erhöhung der Summe</b>
    </p>

    <p>
      Die{' '}
      <b>Versicherungssumme erhöht sich für einen Zeitraum von bis zu 6 Monaten um 50.000 €</b> bei Ereignissen wie Heirat,
      Geburt oder Adoption eines Kindes oder Abschluss eines Darlehensvertrags für den Kauf oder Bau einer Immobilie.
      Dieses Extra erhöht den Hinterbliebenenschutz vorübergehend, bis Sie den Vertragsumfang bei Bedarf dauerhaft anpassen.
    </p>
    <p>
      <b>Gut zu wissen:</b><br/>
      Bei der <b>temporären Erhöhung Plus</b> im <b>Premium-Tarif</b> kommen zusätzlich Existenzgründung/Selbstständigkeit,
      Übernahme einer Kanzlei, Notariat oder Praxis als Ereignisse hinzu.
    </p>
  </div>
);

export const HELP_FOR_RELATIVES_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Soforthilfe für Angehörige</b>
    </p>

    <p>
      Unabhängig von der Prüfung für die volle Versicherungssumme: Ihre Hinterbliebenen erhalten
      gegen Vorlage des Versicherungsscheins und der{' '}
      <b>Sterbeurkunde sofort 10 % der Versicherungssumme bis zu einem Betrag von 10.000 €</b>,
      sofern der Vertrag mind. 3 Jahre bestanden hat. Damit können Ihre Hinterbliebenen sofort
      fällige Rechnungen wie Bestattungskosten begleichen.
      <br /> Der ausgezahlte Betrag (Soforthilfe) wird nach der Leistungsprüfung von der
      vereinbarten Versicherungssumme abgezogen.
    </p>
  </div>
);

export const BENEFITS_FROM_BASIC_AND_KONFORT_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Inklusive aller Leistungen aus dem Grund- und Komfortschutz</b>
    </p>

    <p>In Premium enthalten sind alle Leistungen aus dem Grund- und Komfortschutz, wie z. B.:</p>
    <ul>
      <li>Erweiterte Erhöhung der Versicherungssumme ohne erneute Gesundheitsprüfung</li>
      <li>Temporäre Erhöhung der Versicherungssumme</li>
      <li>Soforthilfe für Angehörige</li>
      <li>Auszahlung der Versicherungssumme ohne Wartezeit</li>
      <li>Vorgezogene Todesfallleistung bei schwerer Krankheit</li>
    </ul>
  </div>
);

export const ORPHAN_PROTECTION_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Monatlicher Waisenschutz für jedes Kind bis 18 Jahre</b>
    </p>

    <p>
      Nur bei ERGO erhalten Sie im Premium-Tarif den <b>Kinderschutz Plus</b>: Im Todesfall erhalten Ihre <b>minderjährigen Kinder
      zusätzlich</b> eine Zahlung von <b>250 € monatlich</b>. Falls das hinterbliebene Kind <b>als Vollwaise</b> gilt,
      erhält es eine <b>monatliche Unterstützung von 500 € bis zum 18. Geburtstag</b>.
      Das gilt für leibliche und adoptierte Kinder, inkl. der Kinder, die Sie noch während der Vertragslaufzeit bekommen.
      Eine Vollwaise ist definiert als ein Kind, dessen Elternteile beide verstorben sind.
    </p>
    <p>
      Diese monatliche Leistung ist <b>unabhängig vom Bezug oder der Höhe der gesetzlichen Waisenrente</b>, die nur eine geringe Grundabsicherung bietet.
      So sind Ihre Kinder bis zur Volljährigkeit finanziell noch besser abgesichert.
      Selbst dann, wenn die Versicherungssumme, die an die bezugsberechtige Person ausgezahlt wird, beispielsweise für die Ablösung eines Darlehens oder wichtiger Sanierungen und Anschaffungen vorzeitig aufgebraucht sein sollte.
    </p>
  </div>
);

export const MEDICAL_OPINION_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Verlängerung der Laufzeit um 15 Jahre ohne erneute Gesundheitsprüfung</b>
    </p>
    <p>
      Sie können{' '}
      <b>
        im Premium-Tarif die Laufzeit einmalig ohne erneute Gesundheitsprüfung um max. 15 Jahre
        verlängern
      </b>
      . In diesem Zusammenhang werden Sie lediglich gefragt, ob Sie rauchen.
    </p>
  </div>
);

export const BONUS_LIFETIME_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Pflegebonus bis 15.000 € zu Lebzeiten</b>
    </p>
    <p>
      Im Premium-Tarif haben Sie die Möglichkeit,{' '}
      <b>
        eine Einmalleistung von 10 % der Versicherungssumme bis zu einem maximalen Betrag von 15.000
        € zu erhalten, wenn Sie erstmalig als pflegebedürftig eingestuft werden
      </b>
      . Ihre Versicherungssumme bleibt dabei unverändert. Damit können Sie z. B. wichtige Umbauten
      im Haus oder am Auto durchführen lassen und Zuzahlungen für Pflegezubehör begleichen.
    </p>
  </div>
);

export const SECOND_OPINION_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Kostenlose medizinische Zweitmeinung</b>
    </p>
    <p>
      Wenn Sie bei einer ärztlichen Diagnose unsicher sind, haben Sie die Möglichkeit,{' '}
      <b>
        kostenlos eine medizinische Zweitmeinung von einem Experten des Netzwerks „Best Doctors“
      </b>{' '}
      einzuholen. Ein Fachspezialist prüft Ihren Fall unabhängig und unterstützt Sie dabei, die
      beste Behandlung zu finden.
    </p>
  </div>
);

export const DREAD_DISEASE_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Sofortleistung Dread Disease</b>
    </p>
    <p>
      Bei <b>Diagnose Krebs, Herzinfarkt oder Schlaganfall</b> erhalten Sie schon zu Lebzeiten
      sofort 10 % der Versicherungssumme (max. jedoch 30.000 €) - unabhängig Ihrer weiteren
      Lebenserwartung. Diese Leistung kann bis zu zweimal pro Vertrag in Anspruch genommen werden –
      einmal bei Krebs und einmal bei Herzinfarkt oder Schlaganfall. So können z. B.
      Einkommenseinbußen abgefangen werden.
      <br />
      Die Wartezeit beträgt bei Krebs 3 Monate. Keine Wartezeiten gibt es bei Herzinfarkt oder
      Schlaganfall.
    </p>
  </div>
);

export const SECURITY_PLUS_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Sicherheit Plus</b>
    </p>
    <p>
      Mit <b>Sicherheit Plus</b> bleibt Ihr Beitrag über die gesamte Laufzeit gleich. Garantiert
      ohne Beitragserhöhungen!
    </p>
  </div>
);

export const DYNAMIC_PAYMENT_TOOLTIP = (
  <div className="tooltip">
    <p>
      <b>Beitragsdynamik</b>
    </p>
    <p>
      Wenn Sie die konstante Versicherungssumme vereinbart haben, können Sie eine sogenannte{' '}
      <b>Beitragsdynamik</b> einschließen. Dann steigt Ihr Beitrag jedes Jahr um 3 %. Damit passt
      sich Ihre Versicherungssumme an die steigenden Kosten und Inflation an. Wenn Sie das einmal
      nicht möchten, widersprechen Sie einfach.
    </p>
  </div>
);
